<template>
  <div class="wbPlan">
    <div class="right">
      <div class="header">
        <div class="card-header">
          <div class="title"></div>
        </div>
      </div>

      <div class="action-buttons" v-if="canAdd == 'true'">
        <div class="left-buttons">
          <span class="add-buttons" @click="batchSave">
            <i class="iconfont icon-xinzeng"></i>选择排期</span
          >
        </div>
      </div>

      <div class="tableWrapper">
        <easyTable
          :apiUrl="getProjectTaskByDateUrl"
          :parent="self"
          :config="config1"
          :other="other1"
          ref="table_jsgl1"
          :hidePagination="true"
        >
          <template slot="last" v-if="canAdd == 'true'">
            <el-table-column label="操作" width="320" align="left">
              <template slot-scope="scope">
                <!-- <el-link
                  icon="iconfont icon-xiangqing"
                  type="text"
                  size="small"
                  @click="details(scope.row)"
                  >详情</el-link
                > -->
                <el-link
                  icon="iconfont icon-bianji"
                  type="text"
                  size="small"
                  @click="edit(scope.row)"
                  >指派</el-link
                >
                <el-link
                  icon="iconfont icon-shanchu02"
                  type="text"
                  size="small"
                  @click="del(scope.row)"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </template>
        </easyTable>
      </div>

      <div class="tableWrapper">
        <easyTable
          apiUrl="extra/project/task/queryWbTaskList"
          :parent="self"
          :config="config"
          :other="other"
          ref="table_jsgl"
          @selection-change="selectionChange"
        >
          <template slot="first">
            <el-table-column type="selection" width="55"> </el-table-column>
          </template>
        </easyTable>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      class="editDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm1"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="时段" prop="projectTime">
          <el-select v-model="ruleForm1.projectTime">
            <el-option
              v-for="item in [
                { label: '上午', value: '0' },
                { label: '下午', value: '1' },
                { label: '全天', value: '2' }
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行人员" prop="projectEmp">
          <el-select v-model="ruleForm1.projectEmp" :disabled="showDetail">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm1')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm1')" v-if="!showDetail"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDate } from 'utils'
  export default {
    name: 'wbPlan',
    components: {
      easyTable: () => import('public/easyTable'),
      breadCrumb: () => import('public/breadcrumb')
    },
    data() {
      return {
        canAdd: 'false',
        taskIdList: [],
        userList: [],
        getProjectTaskByDateUrl: 'extra/project/task/getProjectTaskByDate',
        currentDate: new Date().toLocaleString(),
        other: {},
        other1: {},
        showOwnerAddress: false,
        showDetail: false,
        title: '新增',
        adding: false,
        ruleForm1: {
          projectTime: '',
          projectEmp: null,
          empId: null
        },
        rules: {
          projectTime: [
            {
              required: true,
              message: '请选择时段',
              trigger: 'change'
            }
            // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
          ],
          projectEmp: [
            {
              required: true,
              message: '请选择执行人员',
              trigger: 'change'
            }
          ]
        },
        dialogVisible: false,
        searchKeyword: ''
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: row => row.mtStarttime + '-' + row.mtEndtime,
            label: '工单时间'
          },
          {
            prop: row => (row.taskType == 0 ? '例行工单' : '应急工单'),
            label: '工单类型'
          },
          {
            prop: (row, column) =>
              row.mtFrequency == 0
                ? '年'
                : row.mtFrequency == 1
                ? '半年'
                : row.mtFrequency == 2
                ? '季度'
                : row.mtFrequency == 3
                ? '月'
                : '周',
            label: '维保周期'
          },
          {
            prop: 'taskName',
            label: '工单名称'
          },
          {
            prop: 'mtCount',
            label: '设备数量'
          },
          {
            prop: 'userEmpName',
            label: '维保人员'
          }
        ]
      },
      config1() {
        return [
          {
            prop: 'projectDay',
            label: '执行日期'
          },
          {
            prop: (row, column) =>
              row.projectTime == 0
                ? '上午'
                : row.projectTime == 1
                ? '下午'
                : row.projectTime == 2
                ? '全天'
                : '',
            label: '时段'
          },
          {
            prop: 'projectEmpName',
            label: '维保人员'
          },
          {
            prop: 'taskName',
            label: '工单名称'
          },
          {
            prop: (row, column) =>
              row.taskStatus == '0'
                ? '初始化'
                : row.taskStatus == '1'
                ? '已生成工单'
                : row.taskStatus == '2'
                ? '已下发'
                : row.taskStatus == '3'
                ? '已超时'
                : '已完成',
            label: '状态'
          }
        ]
      }
    },
    watch: {
      'ruleForm1.projectEmp': function(newVal) {
        if (newVal) {
          const user = this.userList.find(user => user.id === newVal)
          if (user) {
            this.ruleForm1.empId = user.userId
          } else {
            this.ruleForm1.empId = null // 或者设置为其他默认值
          }
          console.log(this.ruleForm1.empId)
        } else {
          this.ruleForm1.empId = null // 或者设置为其他默认值
        }
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      edit(row) {
        this.showDetail = false
        this.dialogVisible = true
        this.adding = false
        this.title = '指派'
        this.ruleForm1 = { ...row }
      },
      // details(row) {
      //   this.showDetail = true;
      //   this.dialogVisible = true;
      //   this.adding = false;
      //   this.title = "详情单位信息";
      //   this.ruleForm = { ...row };
      // },
      del(row) {
        this.$confirm('是否确定删除该条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axiosget(`extra/project/task/deleteById/${row.id}`).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.$nextTick(this.$refs['table_jsgl1'].getData)
          })
        })
      },

      searchAddress(keyword, callBack) {
        if (this._search)
          this._search.search(keyword, (status, result) => {
            if (status === 'complete') {
              result.tips = result.tips.filter(value => {
                return value.location !== ''
              })
              callBack(result.tips)
            }
          })
      },
      selectAddress(value) {
        console.log(value)
        this.showOwnerAddress = true
        this.ruleForm.ownerAddress = value.name
        console.log(this.ruleForm)
        this.center = [value.location.Q, value.location.R]
        if (this.vueMap) this.vueMap.setCenter(this.center)
        if (this.PosPicker) this.PosPicker.start(value.location)
        console.log(this.ruleForm)
      },
      setCenter() {
        if (this.info.lng && this.info.lat) {
          this.center = [Number(this.info.lng), Number(this.info.lat)]
          if (this.PosPicker) this.PosPicker.start(new AMap.LngLat(this.center[0], this.center[1]))
        }
        if (this.vueMap) this.vueMap.setCenter(this.center)
      },
      search() {
        this.other = {
          searchContent: this.searchKeyword
        }
        this.$nextTick(this.$refs['table_jsgl'].getData)
      },
      submitForm(formName) {
        console.log(this[formName])
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.adding) {
              // this.$axiospost("extra/project/task/update", {
              //   ...this.ruleForm,
              // }).then(res => {
              //   this.$message.success("新增成功！");
              //   this.dialogVisible = false;
              //   this.$nextTick(this.$refs["table_jsgl"].getData);
              //   this.updateCurrentDate();
              // });
            } else {
              this.$axiospost('extra/project/task/update', {
                ...this.ruleForm1
              }).then(res => {
                this.$message.success('指派成功！')
                this.dialogVisible = false
                this.$nextTick(this.$refs['table_jsgl1'].getData)
                this.updateCurrentDate()
              })
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleClose() {
        this.resetForm('ruleForm1')
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
        this.dialogVisible = false
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleEdit(index, row) {
        console.log(index, row)
      },
      handleDelete(index, row) {
        console.log(index, row)
      },
      getStatusType(status) {
        switch (status) {
          case '未开始':
            return 'info'
          case '进行中':
            return 'warning'
          case '已完成':
            return 'success'
          default:
            return 'info'
        }
      },
      format(val, percent) {
        return `${percent}/51`
      },
      changePlan(item) {
        this.activePlan = item.id
      },
      filterHandler(value, row, column) {
        const property = column['property']
        return row[property] === value
      },
      updateCurrentDate() {
        this.currentDate = new Date().toLocaleString()
      },
      batchSave() {
        console.log(this.taskIdList.length)

        if (this.taskIdList.length) {
          this.$axiospost('extra/project/task/batchSave', {
            projectDay: this.other.dateTime,
            taskIdList: this.taskIdList
          }).then(res => {
            this.$message.success('排期成功！')
            this.$nextTick(this.$refs['table_jsgl'].getData)
            this.$nextTick(this.$refs['table_jsgl1'].getData)
          })
        } else {
          this.$message.error('请选择要排期的任务！')
        }
      },
      selectionChange(val) {
        this.taskIdList = []
        console.log(val)
        val.forEach(e => {
          this.taskIdList.push(e.taskId)
        })
      },
      getCompany() {
        this.$axiosget('extra/project/task/queryEmpList').then(res => {
          this.userList = res.data.data
        })
      }
    },
    mounted() {
      this.updateCurrentDate()
      this.getCompany()
    },
    created() {
      this.other.dateTime = this.$route.query.dateTime
      this.canAdd = this.$route.query.canAdd || false
      this.getProjectTaskByDateUrl += '/' + this.$route.query.dateTime
      console.log('获取到的 dateTime:', this.$route.query.dateTime, this.canAdd)
    }
  }
</script>

<style lang="less" scoped>
  // 定义变量
  @primary-color: #3d80ff;
  @text-color: #0c1833;
  @border-color: #e6eaf9;
  @bg-color: #f3f6ff;
  @font-family: MicrosoftYaHei;

  // 定义混合器
  .flex-center(@content: center) {
    display: flex;
    align-items: center;
    justify-content: @content;
  }

  .wbPlan {
    padding: 0.24rem 0.51rem 0 0.28rem;
    display: flex;

    .custom-breadcrumb {
      height: 0.49rem;
      background-color: #f3f6ff;
      border-radius: 0.06rem;
      margin-bottom: 0.16rem;
      display: flex;
      align-items: center;
      padding-left: 0.15rem;

      .iconfont {
        font-size: 0.24rem;
        color: #727c90;
        cursor: pointer;
      }

      .breadcrumb-title {
        font-family: MicrosoftYaHei;
        font-size: 0.14rem;
        color: #747474;
        margin: 0 0.14rem;

        &-active {
          font-weight: bold;
          color: #222;
          margin: 0 0.08rem;
        }
      }

      .right-arrow {
        width: 0.09rem;
        height: 0.1rem;
      }
    }

    .right {
      flex: 1;
      padding-bottom: 0.2rem;
      overflow-y: auto;

      .header {
        background: #fff;
        .card-header {
          height: 0.56rem;
          inset: 0;
          display: flex;
          justify-content: space-between;
          background: #3e69eb;
          .title {
            margin-top: 0.14rem;
            margin-left: 0.36rem;
            font-family: MicrosoftYaHei;
            font-size: 0.18rem;
            font-weight: bold;
            color: #fff;
          }

          .right-header {
            margin-right: 0.23rem;
            display: flex;
            align-items: center;

            .date {
              font-family: MicrosoftYaHei;
              font-size: 0.14rem;
              color: #fff;
            }

            .search {
              margin-left: 0.1rem;
              width: 2.2rem;
              background: #fff;
              border-radius: 0.08rem;

              .el-input {
                /deep/ .el-input__inner {
                  height: 0.35rem;
                  line-height: 0.35rem;
                  background-color: #e9f1ff;
                  border-radius: 0.06rem;
                  border: none;
                  padding-left: 0.35rem;
                  font-size: 0.14rem;
                }

                /deep/ .el-input__prefix {
                  left: 0.09rem;

                  i {
                    font-size: 0.18rem;
                    color: #727c90;
                    line-height: 0.35rem;
                  }
                }
              }
            }
          }
        }
      }

      .action-buttons {
        margin-top: 0.14rem;
        margin-bottom: 0.14rem;
        .flex-center(space-between);

        .left-buttons {
          display: flex;
          align-items: center;

          span {
            cursor: pointer;
          }

          .init-buttons {
            width: 1.56rem;
            height: 0.52rem;
            background-color: @bg-color;
            border-radius: 0.09rem;
            .flex-center();
            font-family: MicrosoftYaHei;
            font-size: 0.16rem;
            font-weight: bold;
            color: #333;
            margin-right: 0.2rem;

            .iconfont {
              font-size: 0.23rem;
              color: #3d5eff;
              margin-right: 0.12rem;
            }
          }

          .add-buttons,
          .delete-buttons {
            .flex-center();
            font-family: MicrosoftYaHei;
            font-size: 0.16rem;
            color: #626262;

            .iconfont {
              font-size: 0.21rem;
              color: #3d5eff;
              margin-right: 0.05rem;
            }

            &:hover {
              color: #3d5eff;
            }
          }

          .delete-buttons {
            margin-left: 0.14rem;
          }
        }

        .right-buttons {
          .manage-buttons {
            width: 1.78rem;
            height: 0.52rem;
            background-color: #fff;
            border-radius: 0.26rem;
            border: 0.01rem solid #acacac;
            .flex-center();
            font-family: MicrosoftYaHei;
            font-size: 0.16rem;
            font-weight: bold;
            color: #333;
            cursor: pointer;

            .iconfont {
              font-size: 0.2rem;
              color: #797979;
              margin-right: 0.12rem;
            }
          }
        }
      }

      .tableWrapper {
        background: #001D49;
        .stripeTable {
          /deep/ .el-progress-bar__outer {
            height: 12px !important;
            background: #dce4fd;
          }

          /deep/ .el-progress__text {
            font-size: 14px !important;
            color: #333;
          }
        }
      }
    }
  }
/deep/ .el-pagination button:disabled{
  background: transparent;
  border: 1px solid #0C87F1;
}
/deep/ .el-pager li.active{
  background: #0D90FF;
  color: #ccc;
}
/deep/ .el-pager li{
  background: #0a6de7;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/maintenance/projectManage/projectSchedule/dailySchedule.vue